export default "__VITE_ASSET__MrImUpqk__"